import React, { Component } from 'react';
import './card-footer.css';

class GeckoCardFooter extends Component {

    render() {
        return (
        	<div className="footer">
				{this.props.children}
			</div>         
        );
    }
}

export default GeckoCardFooter;